import { Injectable } from '@angular/core';
import { BaseProvider } from '../providers/base-provider';
import { RoleMenusNotifier } from './role-menus-notifier';
import { RoleMenusState } from './role-menus-state';

/** Singleton de sesión: los menús del rol se descartan al cerrar sesión. */
@Injectable({ providedIn: 'root' })
export class RoleMenusProvider extends BaseProvider<RoleMenusNotifier, RoleMenusState> {
  constructor() {
    super(RoleMenusNotifier);
    this.trackSessionReset(() => this.notifier.reset());
  }
}
